export const DATA_QA_MOBILE_FOOTER_CONTAINER = 'mobile-fixed-menu';
